"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XWMMMXUKcjs = require('./XWMMMXUK.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/composite/composite-context.tsx
var _react = require('react');
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_XWMMMXUKcjs.CollectionContextProvider],
  [_XWMMMXUKcjs.CollectionScopedContextProvider]
);
var useCompositeContext = ctx.useContext;
var useCompositeScopedContext = ctx.useScopedContext;
var useCompositeProviderContext = ctx.useProviderContext;
var CompositeContextProvider = ctx.ContextProvider;
var CompositeScopedContextProvider = ctx.ScopedContextProvider;
var CompositeItemContext = _react.createContext.call(void 0, 
  void 0
);
var CompositeRowContext = _react.createContext.call(void 0, 
  void 0
);









exports.useCompositeContext = useCompositeContext; exports.useCompositeScopedContext = useCompositeScopedContext; exports.useCompositeProviderContext = useCompositeProviderContext; exports.CompositeContextProvider = CompositeContextProvider; exports.CompositeScopedContextProvider = CompositeScopedContextProvider; exports.CompositeItemContext = CompositeItemContext; exports.CompositeRowContext = CompositeRowContext;
